module.exports = __webpack_public_path__ + "img/anggaran-dasar.403061e7.png";